import { createFileRoute } from '@tanstack/react-router'
import { useCallback } from 'react'

import { PortalScenarioPlayer } from '@/components/portal/portal-scenario-player'
import type { ScenarioSearch } from '@/components/scenario/scenario-player'
import { isQaFilter } from '@/lib/qa-player'

/** `?cas=&etape=` (ou `?fin=true`) garde la position ; `?filtre=` choisit les cas. */
function readSearch(search: Record<string, unknown>): ScenarioSearch {
  return {
    filtre: isQaFilter(search.filtre) && search.filtre !== 'internes' ? search.filtre : 'tous',
    ...(typeof search.cas === 'string' && search.cas ? { cas: search.cas } : {}),
    ...(typeof search.etape === 'string' && search.etape ? { etape: search.etape } : {}),
    ...(search.fin === true || search.fin === 'true' ? { fin: true } : {}),
  }
}

export const Route = createFileRoute('/portal/projets/$projectId_/livrables/$key_/tester')({
  validateSearch: readSearch,
  component: PortalScenarioRoute,
})

function PortalScenarioRoute() {
  const { projectId, key } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const onNavigate = useCallback(
    (next: ScenarioSearch) => {
      void navigate({ search: next, replace: true })
    },
    [navigate],
  )
  const onQuit = useCallback(() => {
    void navigate({ to: '/portal/projets/$projectId/livrables/$key', params: { projectId, key } })
  }, [navigate, projectId, key])

  return (
    <PortalScenarioPlayer
      key={`${projectId}:${key}`}
      projectId={projectId}
      deliverableKey={key}
      search={search}
      onNavigate={onNavigate}
      onQuit={onQuit}
    />
  )
}
